// extracted by mini-css-extract-plugin
export default {"container":"TextContent_container__cOVsc","underline":"TextContent_underline__MR9ZD","previewItem":"TextContent_previewItem__2tnih","apyText":"TextContent_apyText__tPlDx"};